import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Smile, Users, Sparkles } from 'lucide-react';
import { useProgress } from '../context/ProgressContext';
export function BodyPositivityPage() {
  const navigate = useNavigate();
  const {
    progress
  } = useProgress();
  const modules = [{
    id: 'body-acceptance',
    title: 'Your Body is Amazing',
    icon: Heart,
    description: 'Learn to appreciate your unique body',
    color: 'from-pink-500 to-rose-500',
    content: ["Your body is YOURS - it doesn't need to look like anyone else's", 'Bodies come in all shapes, sizes, colors, and abilities - all are beautiful', "Your worth isn't determined by your appearance or weight", 'Social media shows edited, filtered versions - not reality', 'Focus on what your body can DO, not just how it looks', 'Comparison is the thief of joy - your only competition is yourself']
  }, {
    id: 'puberty-changes',
    title: 'Puberty & Body Changes',
    icon: Sparkles,
    description: 'Understanding natural body transformations',
    color: 'from-purple-500 to-pink-500',
    content: ["Everyone goes through puberty at different times - there's no 'right' timeline", 'Weight gain during puberty is NORMAL and necessary for development', 'Stretch marks, acne, body hair - all completely natural', "It's normal for breasts to be different sizes or shapes", 'Your body shape will change - hips widen, shoulders broaden, etc.', "Bodies don't stop changing after puberty - change is lifelong and normal"]
  }, {
    id: 'media-literacy',
    title: 'Social Media Reality Check',
    icon: Users,
    description: 'See through filters and unrealistic standards',
    color: 'from-blue-500 to-cyan-500',
    content: ['90% of images you see online are edited or filtered', 'Influencers use lighting, angles, posing, and editing apps', "Even models don't look like their photos in real life", 'Unfollow accounts that make you feel bad about yourself', 'Follow diverse bodies - all shapes, sizes, ages, abilities', 'Remember: People post highlights, not their full reality']
  }, {
    id: 'self-care',
    title: 'Loving Your Body',
    icon: Smile,
    description: 'Build a positive relationship with yourself',
    color: 'from-teal-500 to-green-500',
    content: ['Replace "I hate my..." with "I appreciate my body for..."', 'Wear clothes that make YOU feel comfortable and confident', "Don't let anyone comment on your body - it's not their business", 'Practice positive self-talk: Would you say this to a friend?', 'Take care of your body because you LOVE it, not because you hate it', 'Surround yourself with people who celebrate you as you are']
  }];
  return <div className="min-h-screen w-full bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50 dark:from-slate-900 dark:via-pink-950 dark:to-purple-950 pb-20 md:pb-8" data-id="element-289">
      <header className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-pink-100 dark:border-slate-700 sticky top-0 z-10" data-id="element-290">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-291">
          <button onClick={() => navigate('/home')} className="flex items-center space-x-2 text-pink-600 dark:text-pink-400 hover:text-pink-700 dark:hover:text-pink-300" data-id="element-292">
            <ArrowLeft className="w-5 h-5" data-id="element-293" />
            <span className="font-medium" data-id="element-294">Home</span>
          </button>
          <h1 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-295">
            Body Positivity
          </h1>
          <div className="w-20" data-id="element-296" />
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-297">
        <div className="text-center mb-8" data-id="element-298">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3" data-id="element-299">
            Love Your Body, {progress.preferences.name || 'Friend'}! 💖
          </h2>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-300">
            Your body is amazing just as it is. Learn to appreciate, accept, and
            celebrate your unique self!
          </p>
        </div>
        <div className="space-y-6" data-id="element-301">
          {modules.map(module => {
          const Icon = module.icon;
          return <div key={module.id} className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg overflow-hidden" data-id="element-302">
                <div className={`h-24 bg-gradient-to-br ${module.color} flex items-center px-6`} data-id="element-303">
                  <Icon className="w-10 h-10 text-white mr-4" data-id="element-304" />
                  <div data-id="element-305">
                    <h3 className="text-2xl font-bold text-white" data-id="element-306">
                      {module.title}
                    </h3>
                    <p className="text-white/90 text-sm" data-id="element-307">
                      {module.description}
                    </p>
                  </div>
                </div>
                <div className="p-6" data-id="element-308">
                  <ul className="space-y-3" data-id="element-309">
                    {module.content.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-310">
                        <div className={`w-6 h-6 bg-gradient-to-br ${module.color} rounded-full flex items-center justify-center flex-shrink-0 mt-0.5`} data-id="element-311">
                          <span className="text-white text-xs font-bold" data-id="element-312">
                            {index + 1}
                          </span>
                        </div>
                        <p className="text-gray-700 dark:text-gray-300" data-id="element-313">
                          {item}
                        </p>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
        <div className="mt-8 bg-pink-50 dark:bg-slate-800 border-l-4 border-pink-500 rounded-lg p-6" data-id="element-314">
          <h4 className="font-bold text-pink-900 dark:text-pink-300 mb-2" data-id="element-315">
            You Are Enough! 💕
          </h4>
          <p className="text-pink-800 dark:text-pink-200" data-id="element-316">
            Your body is not an ornament to be looked at - it's a vessel to live
            your life in! Focus on health, happiness, and being kind to
            yourself. You deserve love and respect exactly as you are right now.
          </p>
        </div>
      </div>
    </div>;
}